import { apiPost, apiGet } from './client';

export async function submitTicket({ title, description, category }) {
  return apiPost('/tickets', {
    title,
    description,
    category,
    page: window.location.pathname,
    userAgent: navigator.userAgent,
  });
}

export async function getMyTickets() {
  return apiGet('/tickets');
}
